import { render, staticRenderFns } from "./departmentManagement.vue?vue&type=template&id=a7b0613c&scoped=true&"
import script from "./departmentManagement.vue?vue&type=script&lang=js&"
export * from "./departmentManagement.vue?vue&type=script&lang=js&"
import style0 from "./departmentManagement.vue?vue&type=style&index=0&id=a7b0613c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b0613c",
  null
  
)

export default component.exports